(function () {
  // Åbningstider: JS ugedag-numre (0=søndag ... 4=torsdag, 5=fredag, 6=lørdag)
  var OPENING_HOURS = {
    4: { start: '13:00', end: '17:00', label: 'Torsdag' },
    5: { start: '13:00', end: '17:00', label: 'Fredag' },
    6: { start: '11:00', end: '15:00', label: 'Lørdag' }
  };

  var DATE_ATTR_KEY = 'Afhentningsdato';
  var TIME_ATTR_KEY = 'Afhentningstidspunkt';
  var LABEL_ATTR_KEY = 'Afhentning';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function isoDate(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function formatDanish(d) {
    try {
      return d.toLocaleDateString('da-DK', { weekday: 'long', day: 'numeric', month: 'long' });
    } catch (e) {
      return OPENING_HOURS[d.getDay()].label + ' ' + isoDate(d);
    }
  }

  function getEarliestOrderableDate() {
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    // Omregn JS-ugedag (0=søndag) til mandag-baseret indeks: mandag=0 ... søndag=6
    var isoDow = (now.getDay() + 6) % 7;
      // Torsdag = isoDow 3. Mandag/tirsdag (0-1) -> bestil til denne uges torsdag.
    // Onsdag-søndag (2-6) -> bestillingsfristen (tirsdag) er passeret, spring til næste uges torsdag.
    var offsetToThursday = isoDow <= 1 ? 3 - isoDow : 3 - isoDow + 7;
    var earliest = new Date(now);
    earliest.setDate(now.getDate() + offsetToThursday);
    return earliest;
  }

  function getValidDates(daysAhead) {
    var dates = [];
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    var earliest = getEarliestOrderableDate();
    var limit = daysAhead || 30;
    for (var i = 0; i < limit; i++) {
      var check = new Date(d);
      check.setDate(d.getDate() + i);
      if (OPENING_HOURS[check.getDay()] && check >= earliest) {
        dates.push(check);
      }
    }
    return dates;
  }

  function getTimeSlots(weekday) {
    var hours = OPENING_HOURS[weekday];
    if (!hours) return [];
    var slots = [];
    var start = hours.start.split(':').map(Number);
    var end = hours.end.split(':').map(Number);
    var cur = start[0] * 60 + start[1];
    var stop = end[0] * 60 + end[1];
    while (cur <= stop) {
      slots.push(pad(Math.floor(cur / 60)) + ':' + pad(cur % 60));
      cur += 30;
    }
    return slots;
  }

  function initScheduler(root) {
    var dateSelect = root.querySelector('[data-pickup-date]');
    var timeSelect = root.querySelector('[data-pickup-time]');
    var status = root.querySelector('[data-pickup-status]');
    var daysAhead = parseInt(root.getAttribute('data-days-ahead'), 10) || 30;

    var validDates = getValidDates(daysAhead);

    validDates.forEach(function (d) {
      var opt = document.createElement('option');
      opt.value = isoDate(d);
      opt.textContent = formatDanish(d).charAt(0).toUpperCase() + formatDanish(d).slice(1);
      opt.dataset.weekday = d.getDay();
      dateSelect.appendChild(opt);
    });

    function updateStatus(text, isError) {
      status.textContent = text;
      status.classList.toggle('pickup-scheduler-status--error', !!isError);
      status.classList.toggle('pickup-scheduler-status--ok', !isError && !!text);
    }

    function saveToCart() {
      var dateVal = dateSelect.value;
      var timeVal = timeSelect.value;
      if (!dateVal || !timeVal) return;

      var selectedOption = dateSelect.options[dateSelect.selectedIndex];
      var readableLabel = selectedOption.textContent + ' kl. ' + timeVal;

      var attributes = {};
      attributes[DATE_ATTR_KEY] = dateVal;
      attributes[TIME_ATTR_KEY] = timeVal;
      attributes[LABEL_ATTR_KEY] = readableLabel;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      })
        .then(function (res) {
          if (res.ok) {
            updateStatus('✓ Afhentning valgt: ' + readableLabel, false);
            root.dataset.pickupComplete = 'true';
          } else {
            updateStatus('Der gik noget galt, prøv igen.', true);
            root.dataset.pickupComplete = 'false';
          }
        })
        .catch(function () {
          updateStatus('Der gik noget galt, prøv igen.', true);
          root.dataset.pickupComplete = 'false';
        });
    }

    dateSelect.addEventListener('change', function () {
      var selected = dateSelect.options[dateSelect.selectedIndex];
      timeSelect.innerHTML = '';
      root.dataset.pickupComplete = 'false';
      updateStatus('', false);

      if (!selected || !selected.value) {
        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Vælg en dag først...';
        timeSelect.appendChild(placeholder);
        timeSelect.disabled = true;
        return;
      }

      var weekday = parseInt(selected.dataset.weekday, 10);
      var slots = getTimeSlots(weekday);

      var firstOpt = document.createElement('option');
      firstOpt.value = '';
      firstOpt.textContent = 'Vælg et tidspunkt...';
      timeSelect.appendChild(firstOpt);

      slots.forEach(function (slot) {
        var opt = document.createElement('option');
        opt.value = slot;
        opt.textContent = slot;
        timeSelect.appendChild(opt);
      });

      timeSelect.disabled = false;
    });

    timeSelect.addEventListener('change', function () {
      if (timeSelect.value) {
        saveToCart();
      } else {
        root.dataset.pickupComplete = 'false';
        updateStatus('', false);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pickup-scheduler]:not([data-pickup-initialized])').forEach(function (root) {
      root.setAttribute('data-pickup-initialized', 'true');
      initScheduler(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);

  // Bloker "Gå til betaling" indtil afhentning er valgt
  document.addEventListener(
    'click',
    function (e) {
      var scheduler = document.querySelector('[data-pickup-scheduler]');
      if (!scheduler) return;

      var target = e.target.closest(
        'a[href="/checkout"], a[href^="/checkout?"], button[name="checkout"], input[name="checkout"]'
      );
      if (!target) return;

      if (scheduler.dataset.pickupComplete !== 'true') {
        e.preventDefault();
        e.stopPropagation();
        var status = scheduler.querySelector('[data-pickup-status]');
        if (status) {
          status.textContent = 'Vælg venligst afhentningsdag og -tid før du fortsætter.';
          status.classList.add('pickup-scheduler-status--error');
          status.classList.remove('pickup-scheduler-status--ok');
        }
        scheduler.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    true
  );
})();